import {
  ApplicationRef,
  ENVIRONMENT_INITIALIZER,
  EnvironmentProviders,
  inject,
  makeEnvironmentProviders,
  NgZone,
} from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { filter } from 'rxjs';

/**
 * Angular 22 uses OnPush as the default for components without an explicit
 * changeDetection strategy. This initializer keeps the UI in sync after
 * navigation and deferred async work (setTimeout, nested subscribe, etc.).
 */
export function provideLegacyChangeDetection(): EnvironmentProviders {
  return makeEnvironmentProviders([
    {
      provide: ENVIRONMENT_INITIALIZER,
      multi: true,
      useValue: () => {
        const appRef = inject(ApplicationRef);
        const ngZone = inject(NgZone);
        const router = inject(Router);

        const refresh = () => {
          ngZone.run(() => {
            Promise.resolve().then(() => appRef.tick());
          });
        };

        router.events
          .pipe(filter((event): event is NavigationEnd => event instanceof NavigationEnd))
          .subscribe(() => refresh());
      },
    },
  ]);
}
